export const getIsFreeDelivery = (culture: string): boolean => {
  const freeDeliveryLocales = parseFreeDeliveryLocalesList('en-in')

  return freeDeliveryLocales.includes(culture.toLowerCase()) ? true : false
}

const parseFreeDeliveryLocalesList = (freeDeliveryLocalesList: string) => {
  if (!freeDeliveryLocalesList) {
    return []
  }

  return freeDeliveryLocalesList.split(',').map((locale) => locale.trim())
}
